// ═══════════════════════════════════════════════════════════════════════════
// LA NAVIGATION (PAGE_VIEW) DANS audit_log — UNE SEULE ÉCRITURE DE LA RÈGLE
//
// Le journal « Module consulté » écrit UNE ligne par changement de page dans
// `audit_log` : action PAGE_VIEW, table_name `navigation`, record_id = l'id de la
// page, details = { module, previous }. C'est du BRUIT pour tout lecteur qui cherche
// un ÉVÉNEMENT : une page ouverte n'est ni une connexion, ni une suppression, ni
// une alerte de sécurité.
//
// Mesuré le 08/10/2026 : `audit_log` reçoit ~176 lignes/jour (max 411). La
// navigation en ajoute quelques centaines. Sans écart, elle ferait trois choses à
// des lecteurs qui n'ont rien demandé (cf. __tests__/journal-navigation-lecteurs-
// cliquet.test.js, qui les recense tous) :
//   · remplir leurs fenêtres de « N dernières lignes » — le tableau de sécurité
//     (500 lignes) et le scan d'anomalies (500) ne verraient plus les connexions
//     échouées d'hier ;
//   · franchir leurs seuils de VOLUME — « 30 actions en 5 min » (RAPID_ACTIONS) et
//     « 200 actions par heure » (HIGH_VOLUME) lèveraient des alertes pour un
//     utilisateur qui travaille normalement ;
//   · polluer le journal d'activité écrit dans le vault Obsidian, une ligne par page.
//
// D'où la règle : la navigation est INVISIBLE de tout lecteur qui ne l'a pas
// demandée. Un lecteur sans filtre d'action écarte `PAGE_VIEW` par `sansNavigation`.
// L'écran qui la veut (AdminActivityPro) la demande explicitement, dans sa propre
// fenêtre : `GET /api/audit?table=navigation`.
//
// Module PUR : aucune dépendance, utilisable côté serveur comme côté navigateur.
// ═══════════════════════════════════════════════════════════════════════════

export const ACTION_PAGE_VIEW = 'PAGE_VIEW';
export const TABLE_NAVIGATION = 'navigation';

/**
 * Écarte la navigation d'une requête supabase-js sur `audit_log`.
 *
 * `action` est NOT NULL dans la table : `neq` n'écarte donc aucune ligne par
 * mégarde (en SQL, `<>` exclut les NULL — ce piège-là est impossible ici).
 *
 * @template T
 * @param {T} requete  un constructeur de requête portant `.neq` (select/filtres)
 * @returns {T}
 */
export function sansNavigation(requete) {
  return requete.neq('action', ACTION_PAGE_VIEW);
}
